// This file is concerned with the configuration of the ICS 207 form
// As such, it depends upon a particular PDF template in order to function as expected
export const FormConfig_ICS207 = {
  formname: 'ICS 207',
  filename: 'ICS_207.PDF',
  form_workflow_group: 'ICS-FEMA',
  page_number_fields: ['IAP Page_6'],
  form_states: [
    {
      state_name: 'Incomplete',
      state_instruction:
        'The Planning Section Chief must fill out the Planning Section of this form.',
      state_node_workflow_settings: {
        // Note, the unique ID for each state/node is the state_name
        data: {},
        position: { x: 250, y: 0 },
        sourcePosition: 'bottom',
      },
    },
    {
      state_name: 'Submitted',
      state_instruction: 'This form is complete.',
      state_node_workflow_settings: {
        // Note, the unique ID for each state/node is the state_name
        data: {},
        position: { x: 250, y: 200 },
        targetPosition: 'top',
      },
    },
  ],
  form_state_transitions: [
    {
      from: 'Incomplete',
      to: 'Submitted',
      action: 'Submit ICS 207',
      transition_conditions: {
        // Things that need to be met for a transition to be allowed
        valid_sections: ['Planning Section'],
        valid_seats: ['Planning Section Chief'],
        repeatable: true, // This allows the transition to be "repeated" - in other words, allow a form to be edited by the authorized users when the record is in the "from" category.
      },
      transition_edge_workflow_settings: {
        // Note, the unique ID for each transition/edge is [from]-to-[to].  ex: "Incomplete-to-Awaiting approval"
        arrowHeadType: 'arrowclosed',
      },
    },
  ],
  sections: [
    {
      section_name: 'Planning Section',
      section_instruction:
        'This part of the form must be filled out by the Planning Section Chief',
      section_state_roles: [
        {
          state_name: 'Incomplete',
          roles: ['Planning Section Chief'],
        },
        {
          state_name: 'Submitted',
          roles: ['Planning Section Chief'],
        },
      ],
      subsections: [
        {
          title: '1. Incident Name',
          type: 'Title',
          subtitle: '',
        },
        {
          type: 'TextInput',
          field: {
            field_id: '1 Incident Name_11',
            field_label: '1. Incident Name',
            inputtype: 'Input-Text',
            autofill: 'getCurrentIncidentName',
            validations: {
              format: 'text',
            },
          },
        },
        {
          title: '2. Operational Period',
          type: 'Title',
          subtitle: 'Date/Time',
        },
        {
          type: 'OPDateTimeGroup',
          fields: [
            {
              field_id: 'Date From',
              field_label: 'Date From:',
              inputtype: 'Input-Date',
              autofill: 'getCurrentOPDateFrom',
              validations: {
                format: 'date',
              },
            },
            {
              field_id: 'Date To',
              field_label: 'Date To:',
              inputtype: 'Input-Date',
              autofill: 'getCurrentOPDateTo',
              validations: {
                format: 'date',
              },
            },
            {
              field_id: 'Time From',
              field_label: 'Time From:',
              inputtype: 'Input-Time',
              autofill: 'getCurrentOPTimeFrom',
              validations: {
                format: 'time',
              },
            },
            {
              field_id: 'Time To',
              field_label: 'Time To:',
              inputtype: 'Input-Time',
              autofill: 'getCurrentOPTimeTo',
              validations: {
                format: 'time',
              },
            },
          ],
        },
        {
          type: 'ListInput',
          field: {
            field_id: 'Incident Commanders_2',
            field_label: 'Incident Commander(s)',
            inputtype: 'Input-List',
            validations: {
              // If this field is required to be "valid" for a state transition, check the validations.  All must be true for the field to be valid.  If this field is not required for a state transition, no check is performed.
              input_required: true, // Must be at least one item with length of > 1.  This will largely be managed by the rendering/handling code.
              format: 'array',
            },
          },
        },
        {
          type: 'TextInput',
          field: {
            field_id: 'Liaison Officer_3',
            field_label: 'Liaison Officer',
            inputtype: 'Input-Text',
            autofill: 'getUserNameBySeatName',
            autofill_settings: {
              seat_name: 'Liaison Officer',
            },
            validations: {
              format: 'text',
            },
          },
        },
        {
          type: 'TextInput',
          field: {
            field_id: 'Safety Officer_4',
            field_label: 'Safety Officer',
            inputtype: 'Input-Text',
            autofill: 'getUserNameBySeatName',
            autofill_settings: {
              seat_name: 'Safety Officer',
            },
            validations: {
              format: 'text',
            },
          },
        },
        {
          type: 'TextInput',
          field: {
            field_id: 'Public Information Officer_4',
            field_label: 'Public Information Officer',
            inputtype: 'Input-Text',
            autofill: 'getUserNameBySeatName',
            autofill_settings: {
              seat_name: 'Public Information Officer',
            },
            validations: {
              format: 'text',
            },
          },
        },
        {
          type: 'TextInput',
          field: {
            field_id: 'Operations Section ChiefRow1',
            field_label: 'Operations Section Chief',
            inputtype: 'Input-Text',
            autofill: 'getUserNameBySeatName',
            autofill_settings: {
              seat_name: 'Operations Section Chief',
            },
            validations: {
              format: 'text',
            },
          },
        },
        {
          type: 'TextInput',
          field: {
            field_id: 'Staging Area Manager',
            field_label: 'Staging Area Manager',
            inputtype: 'Input-Text',
            autofill: 'getUserNameBySeatName',
            autofill_settings: {
              seat_name: 'Staging Area Manager',
            },
            validations: {
              format: 'text',
            },
          },
        },
        {
          type: 'TextInput',
          field: {
            field_id: 'undefined_27',
            field_label: 'Ops Branch 1 Director',
            inputtype: 'Input-Text',
            /*
						autofill: "getUserNameBySeatName",
						autofill_settings: {
							seat_name: "Staging Area Manager"
						},
						*/
            validations: {
              format: 'text',
            },
          },
        },
        {
          type: 'TextInput',
          field: {
            field_id: 'undefined_28',
            field_label: 'Ops Branch 2 Director',
            inputtype: 'Input-Text',
            /*
						autofill: "getUserNameBySeatName",
						autofill_settings: {
							seat_name: "Staging Area Manager"
						},
						*/
            validations: {
              format: 'text',
            },
          },
        },
        {
          type: 'TextInput',
          field: {
            field_id: 'undefined_29',
            field_label: 'Ops Branch 3 Director',
            inputtype: 'Input-Text',
            /*
						autofill: "getUserNameBySeatName",
						autofill_settings: {
							seat_name: "Staging Area Manager"
						},
						*/
            validations: {
              format: 'text',
            },
          },
        },
        {
          type: 'TextInput',
          field: {
            field_id: 'undefined_30',
            field_label: 'Ops Branch 4 Director',
            inputtype: 'Input-Text',
            /*
						autofill: "getUserNameBySeatName",
						autofill_settings: {
							seat_name: "Staging Area Manager"
						},
						*/
            validations: {
              format: 'text',
            },
          },
        },
        {
          type: 'TextInput',
          field: {
            field_id: 'Planning Section Chief_3',
            field_label: 'Planning Section Chief',
            inputtype: 'Input-Text',
            autofill: 'getUserNameBySeatName',
            autofill_settings: {
              seat_name: 'Planning Section Chief',
            },
            validations: {
              format: 'text',
            },
          },
        },
        {
          type: 'TextInput',
          field: {
            field_id: 'Resources Unit Ldr',
            field_label: 'Resources Unit Leader',
            inputtype: 'Input-Text',
            autofill: 'getUserNameBySeatName',
            autofill_settings: {
              seat_name: 'Resources Unit Leader',
            },
            validations: {
              format: 'text',
            },
          },
        },
        {
          type: 'TextInput',
          field: {
            field_id: 'Situation Unit Ldr',
            field_label: 'Situation Unit Leader',
            inputtype: 'Input-Text',
            autofill: 'getUserNameBySeatName',
            autofill_settings: {
              seat_name: 'Situation Unit Leader',
            },
            validations: {
              format: 'text',
            },
          },
        },
        {
          type: 'TextInput',
          field: {
            field_id: 'Documentation Unit Ldr',
            field_label: 'Documentation Unit Leader',
            inputtype: 'Input-Text',
            autofill: 'getUserNameBySeatName',
            autofill_settings: {
              seat_name: 'Documentation Unit Leader',
            },
            validations: {
              format: 'text',
            },
          },
        },
        {
          type: 'TextInput',
          field: {
            field_id: 'Demobilization Unit Ldr',
            field_label: 'Demobilization Unit Leader',
            inputtype: 'Input-Text',
            autofill: 'getUserNameBySeatName',
            autofill_settings: {
              seat_name: 'Demobilization Unit Leader',
            },
            validations: {
              format: 'text',
            },
          },
        },
        {
          type: 'TextInput',
          field: {
            field_id: 'undefined_31',
            field_label: 'Planning Section Member (blank)',
            inputtype: 'Input-Text',
            validations: {
              format: 'text',
            },
          },
        },
        {
          type: 'TextInput',
          field: {
            field_id: 'Logistics Section Chief_2',
            field_label: 'Logistics Section Chief',
            inputtype: 'Input-Text',
            autofill: 'getUserNameBySeatName',
            autofill_settings: {
              seat_name: 'Logistics Section Chief',
            },
            validations: {
              format: 'text',
            },
          },
        },
        {
          type: 'TextInput',
          field: {
            field_id: 'Support Branch Dir',
            field_label: 'Support Branch Director',
            inputtype: 'Input-Text',
            autofill: 'getUserNameBySeatName',
            autofill_settings: {
              seat_name: 'Support Branch Director',
            },
            validations: {
              format: 'text',
            },
          },
        },
        {
          type: 'TextInput',
          field: {
            field_id: 'Supply Unit Ldr',
            field_label: 'Supply Unit Leader',
            inputtype: 'Input-Text',
            autofill: 'getUserNameBySeatName',
            autofill_settings: {
              seat_name: 'Supply Unit Leader',
            },
            validations: {
              format: 'text',
            },
          },
        },
        {
          type: 'TextInput',
          field: {
            field_id: 'Facilities Unit Ldr',
            field_label: 'Facilities Unit Leader',
            inputtype: 'Input-Text',
            autofill: 'getUserNameBySeatName',
            autofill_settings: {
              seat_name: 'Facilities Unit Leader',
            },
            validations: {
              format: 'text',
            },
          },
        },
        {
          type: 'TextInput',
          field: {
            field_id: 'Ground Spt Unit Ldr',
            field_label: 'Ground Support Unit Leader',
            inputtype: 'Input-Text',
            autofill: 'getUserNameBySeatName',
            autofill_settings: {
              seat_name: 'Ground Support Unit Leader',
            },
            validations: {
              format: 'text',
            },
          },
        },
        {
          type: 'TextInput',
          field: {
            field_id: 'Service Branch Dir',
            field_label: 'Service Branch Director',
            inputtype: 'Input-Text',
            autofill: 'getUserNameBySeatName',
            autofill_settings: {
              seat_name: 'Service Branch Director',
            },
            validations: {
              format: 'text',
            },
          },
        },
        {
          type: 'TextInput',
          field: {
            field_id: 'Comms Unit Ldr',
            field_label: 'Communications Unit Leader',
            inputtype: 'Input-Text',
            autofill: 'getUserNameBySeatName',
            autofill_settings: {
              seat_name: 'Communications Unit Leader',
            },
            validations: {
              format: 'text',
            },
          },
        },
        {
          type: 'TextInput',
          field: {
            field_id: 'Medical Unit Ldr',
            field_label: 'Medical Unit Leader',
            inputtype: 'Input-Text',
            autofill: 'getUserNameBySeatName',
            autofill_settings: {
              seat_name: 'Medical Unit Leader',
            },
            validations: {
              format: 'text',
            },
          },
        },
        {
          type: 'TextInput',
          field: {
            field_id: 'Food Unit Ldr',
            field_label: 'Food Unit Leader',
            inputtype: 'Input-Text',
            autofill: 'getUserNameBySeatName',
            autofill_settings: {
              seat_name: 'Food Unit Leader',
            },
            validations: {
              format: 'text',
            },
          },
        },
        {
          type: 'TextInput',
          field: {
            field_id: 'FinanceAdmin Section Chief',
            field_label: 'Finance/Admin Section Chief',
            inputtype: 'Input-Text',
            autofill: 'getUserNameBySeatName',
            autofill_settings: {
              seat_name: 'Finance/Admin Section Chief',
            },
            validations: {
              format: 'text',
            },
          },
        },
        {
          type: 'TextInput',
          field: {
            field_id: 'Time Unit Ldr',
            field_label: 'Time Unit Leader',
            inputtype: 'Input-Text',
            autofill: 'getUserNameBySeatName',
            autofill_settings: {
              seat_name: 'Time Unit Leader',
            },
            validations: {
              format: 'text',
            },
          },
        },
        {
          type: 'TextInput',
          field: {
            field_id: 'Procurement Unit Ldr',
            field_label: 'Procurement Unit Leader',
            inputtype: 'Input-Text',
            autofill: 'getUserNameBySeatName',
            autofill_settings: {
              seat_name: 'Procurement Unit Leader',
            },
            validations: {
              format: 'text',
            },
          },
        },
        {
          type: 'TextInput',
          field: {
            field_id: 'CompClaims Unit Ldr',
            field_label: 'Comp/Claims Unit Leader',
            inputtype: 'Input-Text',
            autofill: 'getUserNameBySeatName',
            autofill_settings: {
              seat_name: 'Comp/Claims Unit Leader',
            },
            validations: {
              format: 'text',
            },
          },
        },
        {
          type: 'TextInput',
          field: {
            field_id: 'Cost Unit Ldr',
            field_label: 'Cost Unit Leader',
            inputtype: 'Input-Text',
            autofill: 'getUserNameBySeatName',
            autofill_settings: {
              seat_name: 'Cost Unit Leader',
            },
            validations: {
              format: 'text',
            },
          },
        },
        {
          type: 'TextInput',
          field: {
            field_id: 'undefined_32',
            field_label: 'Finance/Admin blank',
            inputtype: 'Input-Text',
            autofill: 'getUserNameBySeatName',
            autofill_settings: {
              seat_name: 'Finance/Admin blank',
            },
            validations: {
              format: 'text',
            },
          },
        },
        {
          title: '4. Prepared By',
          subtitle: '',
          type: 'Title',
        },
        {
          type: 'TextInput',
          field: {
            field_id: '4 Prepared by Name_2',
            field_label: 'Name:',
            inputtype: 'Input-Text',
            autofill: 'getCurrentUserName',
            validations: {
              format: 'text',
            },
          },
        },
        {
          type: 'TextInput',
          field: {
            field_id: 'PositionTitle_9',
            field_label: 'Position/Title:',
            inputtype: 'Input-Text',
            autofill: 'getCurrentUserIncidentSeat',
            validations: {
              format: 'text',
            },
          },
        },
        {
          type: 'SignatureInput',
          field: {
            field_id: 'Signature_13',
            field_label: 'Signature:',
            inputtype: 'Input-Signature',
            validations: {
              input_required: true,
            },
          },
        },
        {
          type: 'DatetimeInput',
          field: {
            field_id: 'DateTime_11',
            field_label: 'Date/Time:',
            inputtype: 'Input-Datetime',
            autofill: 'getCurrentDateTime',
            validations: {
              format: 'datetime',
            },
          },
        },
      ],
    },
  ],
};
